<template>
  <div>
    <nav class="navbar">
      <div class="nav-left flex" style="max-width: 70%">
        <button type="button" class="btn btn-back nav-back mr-1" @click="$router.push('/contracts')" />
        <input v-if="$route.name === 'ContractCreate'" class="contract-name" :class="errors.errors.name ? 'contract-name-error' : ''" type="text" v-model="name" placeholder="Enter contract name" />
        <input v-if="$route.name === 'ContractEdit'" class="contract-name" :class="errors.errors.name ? 'contract-name-error' : ''" type="text" v-model="contName" placeholder="Enter contract name" />
        <error-field :errors="errors" field="name" />

        <div class="select" v-if="contractTypes.length" style="min-width: 150px">
          <label class="assignee-title pl-3">Select contract type</label>
          <simple-select
            v-if="$route.name === 'ContractCreate'"
            placeholder="Select option"
            class="assignee-content"
            v-model="contType"
            :options="contractTypes"
            label="name"
          />
          <simple-select
            v-if="$route.name === 'ContractEdit'"
            class="assignee-content"
            v-model="contractType.id"
            :placeholder="contractType.id ? contractType.name: 'Select option'"
            :options="contractTypes"
            label="name"
          />
        </div>

        <div v-if="$route.name === 'ContractCreate'" class="flex">
          <div class="select">
            <label class="assignee-title pl-3" v-if="!errors.errors.company_id">Select company</label>
            <key-multiselect v-model="companyList"
                             :options="companies"
                             :multiple="true"
                             :preserve-search="false"
                             label="name"
                             track-by="id"
                             :limit="companies.length"
                             :hide-selected="true"
            />
            <error-field :errors="errors" field="company_id" />
          </div>
        </div>
        <div v-if="$route.name === 'ContractEdit'" class="nav-center flex flex-column">
          <div class="select">
            <label class="assignee-title pl-3" v-if="!errors.errors.company_id">Select company</label>
            <key-multiselect v-model="contCompanies"
                             :options="companies"
                             :multiple="true"
                             :preserve-search="false"
                             :hide-selected="true"
                             label="name"
                             track-by="id"
                             :limit="companies.length"
            />
            <error-field :errors="errors" field="company_id" />
          </div>
        </div>
      </div>
      <div class="nav-right flex">
        <button class="btn btn-secondary nav-item" v-if="$route.name === 'ContractEdit'" @click="$emit('preview', contractName, contCompanies, active)">
          Preview PDF
        </button>
        <button v-if="$route.name === 'ContractCreate'" class="btn btn-primary nav-item flex flex-column save-button" :disabled="!companyList.length || !name || !contractType" @click="$emit('save', name, companyList, contractActive)">
          <span>
            Create contract
          </span>
        </button>
        <button v-if="$route.name === 'ContractEdit'" class="btn btn-primary nav-item flex flex-column save-button" :disabled="!contCompanies.length || !contName || !contractType.id" @click="$emit('save', contractName, contCompanies, contractActive)">
          <span class="button-text">
            Save contract
          </span>
          <span class="button-time">
            Last saved on {{ contractUpdated }}
          </span>
        </button>
        <div class="dropdown dropleft">
          <button class="btn btn-secondary nav-item nav-menu-button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-ellipsis-v text-dark" />
          </button>
          <div class="dropdown-menu" @submit.prevent="deleteContract" aria-labelledby="dropdownMenuButton">
            <form submit.prevent="deleteContract">
              <div class="switchToggle flex justify-content-between">
                <span>Contract active</span>
                <input type="checkbox" id="switch1" value="false" v-model="contActive" />
                <label for="switch1">Toggle</label>
              </div>
              <div v-if="$route.name === 'ContractEdit'" class="dropdown-divider" />
              <button v-if="$route.name === 'ContractEdit'" class="dropdown-item" href="#" type="submit">
                <i class="fa fa-trash menu-icon" /> Delete contract
              </button>
            </form>
          </div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Errors from '../../classes/Errors';

export default {
  props: {
    contractName: {
      type: String,
      default: '',
    },
    contractType: {
      type: [Object, Number, String],
      default: () => '',
    },
    contractUpdated: {
      type: String,
      default: '',
    },
    contractActive: {
      type: [Number, Boolean],
      default: 0,
    },
    companyIds: {
      type: Array,
      default: () => [],
    },
    companies: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    name: this.contractName,
    active: this.contractActive,
    companyList: [],
    contractTypes: [],
    errors: new Errors(),
  }),
  computed: {
    contType: {
      get() {
        return this.contractType;
      },
      set(value) {
        this.$emit('update:contractType', value);
      },
    },
    contActive: {
      get() {
        return this.contractActive;
      },
      set(value) {
        this.$emit('update:contractActive', value);
      },
    },
    contName: {
      get() {
        return this.contractName;
      },
      set(value) {
        this.$emit('update:contractName', value);
      },
    },
    contCompanies: {
      get() {
        return this.companyIds;
      },
      set(value) {
        this.$emit('update:companyIds', value);
      },
    },
  },
  mounted() {
    this.getContractTypes();
  },
  methods: {
    getContractTypes() {
      axios.get('/values/contract-types').then(res => {
        this.contractTypes = res.data.data;
      });
    },
    deleteContract() {
      axios.delete(`contracts/${this.$route.params.id}`).then(() => {
        toastr.success('Successfully deleted contract');
        this.$router.push('/contracts');
      });
    },
  },
};
</script>

<style scoped>
nav.navbar {
  background-color: #ffffff;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.07);
  z-index: 10;
}

.nav-menu-button {
  min-width: 50px;
}

.nav-back {
  margin: 0 0 0 5px;
}

.nav-left,
.nav-right {
  align-items: center;
}

.nav-left .nav-item {
  margin: 0 12px 0 15px;
}
.nav-item.icon {
  margin-right: 0 !important;
}
.contract-name {
  height: 30px;
  font-size: 22px;
  max-width: 500px;
  min-width: 300px;
}
.save-button {
  max-height: 42px;
}
.nav-right .nav-item {
  margin: 0 8px 0 8px;
}
.button-text {
  font-size: 13px;
  line-height: 1;
}
.button-time {
  font-size: 10px;
}
.switchToggle {
  padding: 15px 15px 0px 16px;
}
.menu-icon {
  padding-right: 10px;
  color: rgb(21, 77, 233);
  font-size: 18px;
}
.multiselect {
  min-width: 150px;
}
@media screen and (max-width: 1190px) {
  .button-time {
    font-size: 6px;
  }
}
@media screen and (max-width: 1025px) {
  .contract-name {
    max-width: 150px;
    min-width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/contracts/ContractNavbar.vue